var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'form-v3-ecommerce': true, 'csr-account-form': true}},[(_setup.showPhoneNav)?_c('div',{staticClass:"csr-account-form__nav-title",on:{"click":() => _setup.clickCancel()}},[_c('div',{staticClass:"csr-account__back__icon"}),_vm._v(" "+_vm._s(_vm.config.personInfo.title)+" ")]):_vm._e(),_c('form',{on:{"submit":function($event){$event.preventDefault();return _setup.submitForm.apply(null, arguments)}}},[_c('div',{staticClass:"csr-account-form__field"},[_c(_setup.FirstName,{ref:"firstNameInput",attrs:{"data-conf":{ 
            label: _vm.config.personInfo.firstnameLabel, 
            placeholder: _vm.config.personInfo.firstnamePlaceholder, 
            required: true,
            name: 'firstName',
            defaultValue: _vm.customer.firstName,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}}),_c(_setup.LastName,{ref:"lastNameInput",attrs:{"data-conf":{ 
            label: _vm.config.personInfo.lastnameLabel, 
            placeholder: _vm.config.personInfo.lastnamePlaceholder, 
            required: true,
            name: 'lastName',
            defaultValue: _vm.customer.lastName,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
          }}})],1),_c('div',{staticClass:"csr-account-form__field--email"},[_c(_setup.Email,{ref:"emailInput",attrs:{"data-conf":{ 
            label: _vm.config.personInfo.emailLabel, 
            placeholder: _vm.config.personInfo.emailPlaceholder, 
            required: true,
            name: 'email',
            defaultValue: _vm.customer.email,
            defErrorMsg: _vm.config.requiredFieldsPrompt,
            formatHint: _vm.config.personInfo.emailFormatPrompt,
            disabled: true, // isB2b,
          }}})],1),_c('div',{staticClass:"csr-account-form__field--phone"},[(_setup.phoneReady)?_c(_setup.Phone,{ref:"phoneNumberInput",attrs:{"data-conf":{
            placeholder: _vm.config.personInfo.phonePlaceholder, 
            label: _vm.config.personInfo.phoneLabel,
             name: 'phone',
             defaultValue: _setup.phoneValue,
              areaCodes: _setup.areaCodes,
              initialAreaCode: _setup.areaCodesVal,
          }},on:{"getAreaCodes":_setup.getAreaCodes}}):_vm._e()],1),_c('div',{staticClass:"csr-account-form__btn-group"},[_c('button',{staticClass:"csr-account-form__btn md-button-v2 md-button md-button--primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.config.confirmButton))]),_c('button',{staticClass:"csr-account-form__btn md-button-v2 md-button md-button--black",attrs:{"type":"button"},on:{"click":() => _setup.clickCancel()}},[_vm._v(_vm._s(_vm.config.cancelButton))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }